import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {TrustiiService} from 'src/app/services/trustii.service';
import {DialogService} from 'src/app/services/dialog.service';

@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.scss']
})
export class SupportComponent implements OnInit {
  messagesent = false;
  messageInProgress = false;
  message = '';
  email = '';

  constructor(private router: Router, private trustiiService: TrustiiService, private dialogService: DialogService) {
  }

  ngOnInit() {
  }

  sendMessage(e) {
    e.preventDefault();
    const payload = {
      message: this.message,
      email: this.email
    };

    this.messageInProgress = true;
    this.trustiiService.support(payload).subscribe(
      (res) => {
        this.messageInProgress = false;
        this.messagesent = true;
        this.dialogService.openAlertDialog(
          '350px',
          '<i class="fa fa-check-circle fa-3x text-success mr-3"></i> Message sent successfully.',
          'Thanks!',
          'Ok',
          'modal-success'
        );
        this.router.navigateByUrl('');
      },
      (err) => {
        this.messageInProgress = false;
        this.dialogService.openAlertDialog(
          '350px',
          '<i class="fa fa-exclamation-circle fa-3x text-warning mr-3"></i> Something went wrong, please try again',
          'Failed to send the message.',
          'Ok',
          'modal-warning'
        );
      }
    );
  }
}
